import { useEffect } from 'react';
import PropTypes from 'prop-types';

const ApiFetcher = function ApiFetcher(props) {
    const {
        query, callback, token,
    } = props;

    async function sendResult(response, statusCode) {
        callback(response, statusCode);
    }

    async function runQuery() {
        fetch(query, {
            method: 'GET',
            headers: token
                ? { Authorization: `Bearer ${token}` }
                : {},
        })
            .then((response) => {
                response.json()
                    .then((j) => {
                        const data = {
                            json: j,
                            statusCode: response.status,
                        };
                        return data;
                    })
                    .then((data) => {
                        sendResult(data.json, data.statusCode);
                    });
            });
    }

    useEffect(() => runQuery(), []);

    return null;
};

ApiFetcher.propTypes = {
    query: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired,
    token: PropTypes.string,
};

ApiFetcher.defaultProps = {
    token: '',
};

export default ApiFetcher;
